import api from "../../service";
import middleware from "../../middleware";

class JournalService extends middleware {
	constructor() {
		super();
		this.url = `${api.defaults.baseURL}/journal`;
	}
	async create(data) {
		const response = await api.post(`${this.url}/notes`, data);
		return response;
	}

	async update(id, data) {
		try {
			const response = await api.put(`${this.url}/notes/${id}`, data, {
				params: {
					db_name: this.db_name,
					user_id: this.user_id,
					user_token: this.user_token,
				},
			});
			return response;
		} catch (error) {
			console.log(error.response.data.message);
		}
	}

	async getAll(filters) {
		const params = {
			db_name: this.db_name,
			user_id: this.user_id,
			user_token: this.user_token,
			...filters
		}
		const response = await api.get(`${this.url}/notes`, {
			params
		});
		return response;
	}

	async getStudentNotes(filters) {
		const response = await api.get(
			`${api.defaults.baseURL}/student/notes`,
			{
				params: {
					...filters,
				},
			},
		);
		return response;
	}

	async getAllDrafts(filters) {
		const params = {
			db_name: this.db_name,
			user_id: this.user_id,
			user_token: this.user_token,
			...filters
		}
		const response = await api.get(`${this.url}/drafts`, {
			params
		});
		return response;
	}

	async get(id) {
		const response = await api.get(`${this.url}/notes/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}

	async getLogs(id) {
		const response = await api.get(`${this.url}/logs/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}

	async delete(id) {
		const response = await api.delete(`${this.url}/notes/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}
	
	async read(id) {
		const response = await api.get(`${this.url}/read/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}

	async unread(id) {
		const response = await api.get(`${this.url}/unread/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}

	async readAll() {
		const params = {
			db_name: this.db_name,
			user_id: this.user_id,
			user_token: this.user_token,
		}
		const response = await api.get(`${this.url}/readAll`, {
			params
		});
		return response;
	}

	async exportSingle(id) {
		const response = await api.get(`${this.url}/notes/export/${id}`, {
			responseType: 'blob',
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}

	async exportMulti(ids) {
		const response = await api.get(`${this.url}/notes/export/multi/${ids}`, {
			responseType: 'blob',
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}

	async journalPlan(id) {
		const response = await api.get(`${this.url}/journalPlan/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}

	async deleteDraft(id) {
		const response = await api.delete(`${this.url}/draft/${id}`, {
			params: {
				db_name: this.db_name,
				user_id: this.user_id,
				user_token: this.user_token,
			},
		});
		return response;
	}
}

export default JournalService
